import './style.scss';
import React from "react";
import Selector from "../selector";

const RESULTS_PER_PAGE_ITEMS = [
  {
    label: 10,
    value: 10
  },
  {
    label: 25,
    value: 25
  },
  {
    label: 50,
    value: 50
  }
]

function ResultsPerPage (props) {
  const {
    value,
    changeAction
  } = props;

  return (
    <div className="results-per-page">
      Show
      <Selector
      id='resultsPerPage'
      name='resultsPerPage'
      label='Result per Page'
      className='results-per-page-input'
      value={value}
      changeAction={changeAction}
      items ={RESULTS_PER_PAGE_ITEMS}/> results per page
    </div>
  );
}

export default ResultsPerPage;